import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "table" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "form-field-floating full" }
const _hoisted_4 = ["onUpdate:modelValue", "id", "onChange"]
const _hoisted_5 = ["value"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "form-field-floating reactive active" }
const _hoisted_8 = ["for"]
const _hoisted_9 = { class: "form-field-floating reactive active" }
const _hoisted_10 = ["for"]
const _hoisted_11 = { class: "form-field-floating reactive active" }
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "form-field-floating reactive active" }
const _hoisted_14 = ["for"]
const _hoisted_15 = {
  colspan: "6",
  class: "text-center"
}

import { reactive, ref, watch } from 'vue';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import { AMOUNT_FORMAT_CONFIG, INTEGER_FORMAT_CONFIG, PERCENTAGE_FORMAT_CONFIG } from '@/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketProduitFormPricesView',
  props: {
        modelValue: { type: Object, default: null },
        startupFormDatas: { type: Object, required: true },
    },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props;
    const emit = __emit;
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const loading = ref(false);
    const formData = reactive({
        echeances: [] as any[],
    });

    watch(props, () => {
        if (props.modelValue) {
            Object.assign(formData, props.modelValue);
            if (formData.echeances.length > 0) {
                formData.echeances.forEach((echeance, index) => {
                    onEcheanceChanged(index);
                });
            }
        }
    }, { deep: true });

    watch(formData, () => {
        emit('update:modelValue', formData);
    }, { deep: true });

    function addEcheance() {
        formData.echeances.push({
            duration: null,
            taux_interet: 0,
            montant_mensualite: 0,
            nombre_mensualites: 0,
            montant_total: 0,
        });
    }

    async function onRemoveEcheance(echeanceIndex: number) {
        const confirmation = await confirmationModalRef.value?.open("Suppression Echéance", "Voulez-vous vraiment supprimer l'échéance sélectionnée ?");
        if (confirmation) {
            formData.echeances.splice(echeanceIndex, 1);
        }
    }

    function onEcheanceChanged(index: number) {
        const selectedEcheance = props.startupFormDatas.echeances.find((echeance: any) => echeance.value === formData.echeances[index].duration);
        if (selectedEcheance) {
            formData.echeances[index].montant_total = parseFloat(props.startupFormDatas.produit.montant) * (1 + (formData.echeances[index].taux_interet / 100));
            formData.echeances[index].montant_mensualite = formData.echeances[index].montant_total / selectedEcheance.coef;
            formData.echeances[index].nombre_mensualites = selectedEcheance.coef;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_money3 = _resolveComponent("money3")!
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, " Gestion des échéances ", -1)),
    _createElementVNode("table", _hoisted_1, [
      _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, "Echéance"),
          _createElementVNode("th", null, "Taux intérêt (%)"),
          _createElementVNode("th", null, "Montant mensualité"),
          _createElementVNode("th", null, "Nombre mensualité"),
          _createElementVNode("th", null, "Montant total"),
          _createElementVNode("th", { width: "10%" })
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (formData.echeances.length == 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("td", { colspan: "6" }, [
                _createElementVNode("div", { class: "text-center text-grey-700" }, "Aucune échéance ajoutée")
              ], -1)
            ]))]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.echeances, (echeance, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: 'echeance_row_' + index
          }, [
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-input-select",
                  "onUpdate:modelValue": ($event: any) => ((echeance.duration) = $event),
                  name: "echeance_duration[]",
                  id: 'echeance_duration_' + index,
                  onChange: ($event: any) => (onEcheanceChanged(index))
                }, [
                  _cache[1] || (_cache[1] = _createElementVNode("option", { value: null }, "Sélectionnez une durée", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.startupFormDatas.echeances, (echeance, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: echeance.value,
                      key: 'echeance_' + index
                    }, _toDisplayString(echeance.text), 9, _hoisted_5))
                  }), 128))
                ], 40, _hoisted_4), [
                  [_vModelSelect, echeance.duration]
                ]),
                _createElementVNode("label", {
                  for: 'echeance_duration_' + index
                }, [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Durée échéance ", -1),
                  _createElementVNode("b", { class: "color-danger" }, "*", -1)
                ]))], 8, _hoisted_6)
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_money3, _mergeProps({
                  class: "form-input",
                  modelValue: echeance.taux_interet,
                  "onUpdate:modelValue": ($event: any) => ((echeance.taux_interet) = $event),
                  name: "taux_interet",
                  id: 'taux_interet_' + index,
                  placeholder: ""
                }, { ref_for: true }, _unref(PERCENTAGE_FORMAT_CONFIG)), null, 16, ["modelValue", "onUpdate:modelValue", "id"]),
                _createElementVNode("label", {
                  for: 'taux_interet_' + index
                }, "Taux intérêt (%)", 8, _hoisted_8)
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_money3, _mergeProps({
                  class: "form-input",
                  modelValue: echeance.montant_mensualite,
                  "onUpdate:modelValue": ($event: any) => ((echeance.montant_mensualite) = $event),
                  name: "montant_mensualite",
                  id: 'montant_mensualite_' + index,
                  placeholder: ""
                }, { ref_for: true }, _unref(AMOUNT_FORMAT_CONFIG), { readonly: true }), null, 16, ["modelValue", "onUpdate:modelValue", "id"]),
                _createElementVNode("label", {
                  for: 'montant_mensualite_' + index
                }, "Montant mensualité", 8, _hoisted_10)
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_money3, _mergeProps({
                  class: "form-input",
                  modelValue: echeance.nombre_mensualites,
                  "onUpdate:modelValue": ($event: any) => ((echeance.nombre_mensualites) = $event),
                  name: "nombre_mensualites",
                  id: 'nombre_mensualites_' + index,
                  placeholder: ""
                }, { ref_for: true }, _unref(INTEGER_FORMAT_CONFIG), { readonly: true }), null, 16, ["modelValue", "onUpdate:modelValue", "id"]),
                _createElementVNode("label", {
                  for: 'nombre_mensualites_' + index
                }, "Nombre mensualité", 8, _hoisted_12)
              ])
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_money3, _mergeProps({
                  class: "form-input",
                  modelValue: echeance.montant_total,
                  "onUpdate:modelValue": ($event: any) => ((echeance.montant_total) = $event),
                  name: "montant_total",
                  id: 'montant_total_' + index,
                  placeholder: ""
                }, { ref_for: true }, _unref(AMOUNT_FORMAT_CONFIG), { readonly: true }), null, 16, ["modelValue", "onUpdate:modelValue", "id"]),
                _createElementVNode("label", {
                  for: 'montant_total_' + index
                }, "Montant total", 8, _hoisted_14)
              ])
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_custom_button, {
                onClick: ($event: any) => (onRemoveEcheance(index)),
                classesList: 'btn-ultra white2 tips'
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("img", {
                    src: "/icons/icon-delete.svg",
                    class: "btn-icon",
                    alt: ""
                  }, null, -1),
                  _createElementVNode("span", null, "Supprimer", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("tfoot", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_15, [
            _createVNode(_component_custom_button, {
              onClick: addEcheance,
              type: "button",
              classesList: 'btn lg w-100',
              loading: loading.value
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("span", null, "Ajouter une échéance", -1)
              ]))]),
              _: 1
            }, 8, ["loading"])
          ])
        ])
      ])
    ])
  ]))
}
}

})